module.exports = "../dist/img/mini-28.757c.jpg";